"use strict";
/* IMPORT */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const ZSTD_BASE64 = require("../zstd/zstd");
const decode_1 = require("./decode");
/* HELPERS */
let heap;
let instance;
/* MAIN */
const ZSTD = {
    /* LIFECYCLE API */
    loadWASM: () => __awaiter(void 0, void 0, void 0, function* () {
        if (instance || heap)
            return;
        const initHeap = () => heap = new Uint8Array(instance.memory.buffer);
        const ZSTD_BUFFER = decode_1.default(ZSTD_BASE64);
        const IMPORTS = { env: { emscripten_notify_memory_growth: initHeap } };
        const wasm = yield WebAssembly.instantiate(ZSTD_BUFFER, IMPORTS);
        instance = wasm.instance.exports; //TSC
        initHeap();
    }),
    /* API */
    decompress: (data, size) => {
        if (!instance || !heap)
            throw new Error(`[zstd] You need to call and await "zstd.loadWASM" first`);
        /* MALLOC-ING COMPRESSED BUFFER */
        const compressedSize = data.byteLength;
        const compressedPointer = instance.malloc(compressedSize);
        heap.set(data, compressedPointer);
        /* MALLOC-ING DECOMPRESSED BUFFER */
        const decompressedSize = size || Number(instance.ZSTD_findDecompressedSize(compressedPointer, compressedSize));
        const decompressedPointer = instance.malloc(decompressedSize);
        /* DECOMPRESSING */
        const decompressedDataSize = instance.ZSTD_decompress(decompressedPointer, decompressedSize, compressedPointer, compressedSize);
        const decompressedData = heap.slice(decompressedPointer, decompressedPointer + decompressedDataSize);
        /* FREE-ING BUFFERS */
        instance.free(compressedPointer);
        instance.free(decompressedPointer);
        /* RETURNING */
        return decompressedData;
    }
};
/* EXPORT */
module.exports = ZSTD;
module.exports.default = ZSTD;
Object.defineProperty(module.exports, "__esModule", { value: true });
